import react, { useEffect } from "react";
import MenuEmpresas from "./menuempresas";
import Box from "@mui/joy/Box";
import Typography from "@mui/joy/Typography";
import Button from "@mui/joy/Button";
import FormControl from "@mui/joy/FormControl";
import FormLabel from "@mui/joy/FormLabel";
import FormHelperText from "@mui/joy/FormHelperText";
import Input from "@mui/joy/Input";
import Textarea from "@mui/joy/Textarea";
import Autocomplete from "@mui/joy/Autocomplete";
import Divider from "@mui/joy/Divider";
import AspectRatio from "@mui/joy/AspectRatio";
import DescriptionIcon from "@mui/icons-material/Description";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import ScheduleIcon from "@mui/icons-material/Schedule";
import PublicIcon from "@mui/icons-material/Public";
import LayersIcon from "@mui/icons-material/Layers";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import Chip from "@mui/joy/Chip";
import { getCountries, getCities } from "countries-cities";
import Calendario from "../crearaventura/subcomponentesaventura/datepicker";
import Mapa from "../mapa";
import axios from "axios";
import imageCompression from "browser-image-compression";
import heic2any from "heic2any";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import ImageIcon from "@mui/icons-material/Image";
import Alert from "@mui/joy/Alert";
import ErrorIcon from "@mui/icons-material/Error";
import HikingIcon from "@mui/icons-material/Hiking";
import { useNavigate } from "react-router-dom";

let Formulario = ({
  formData,
  setFormData,
  pais,
  ciudad,
  setCiudad,
  categorias,
  niveles,
  posicion,
  setPosicion,
  handleDateChange,
  manejarSubirFoto,
  vistaPrevia,
  boton,
  setBoton,
  enviarFormulario,
  estadoBoton,
}) => {
  /* VALOR PESO CHILENO, LO HIZO CHATGPT*/
  function formatearCLP(valor) {
    if (!valor) return "";

    return new Intl.NumberFormat("es-CL", {
      minimumFractionDigits: 0,
    }).format(valor);
  }
  /* VALOR PESO CHILENO, LO HIZO CHATGPT*/

  let Primero = ({}) => {
    return (
      <Box>
        <FormControl>
          <FormLabel>Titulo de la Aventura</FormLabel>
          <Input
            onChange={(x) => {
              setFormData((valoranterior) => ({
                ...valoranterior,
                titulo: x.target.value,
              }));
            }}
            value={formData.titulo}
          />
        </FormControl>
        <FormControl>
          <FormLabel>Descripción</FormLabel>
          <Textarea minRows={4} />
          <FormHelperText>
            Incluye detalles emocionantes sobre la aventura (máximo 300
            caracteres).
          </FormHelperText>
        </FormControl>
      </Box>
    );
  };

  let Segundo = ({}) => {
    return (
      <Box sx={{ display: "grid", gap: 1 }}>
        <FormControl>
          <FormLabel>Pais</FormLabel>
          <Autocomplete
            options={pais}
            onChange={(event, value) => {
              setCiudad(getCities(value));
            }}
          />
        </FormControl>
        <FormControl>
          <FormLabel>Ciudad</FormLabel>
          <Autocomplete disabled={ciudad ? false : true} options={ciudad} />
        </FormControl>
        <FormControl>
          <FormLabel>Fecha de salida</FormLabel>
          <Calendario onDateChange={handleDateChange} />
        </FormControl>
      </Box>
    );
  };
  let Tercero = ({}) => {
    return (
      <Box sx={{ display: "grid", gap: 1 }}>
        <FormControl>
          <FormLabel>Ubicacion</FormLabel>
          <Mapa
            onLocationSelect={(data) => {
              setFormData((prevData) => ({
                ...prevData,
                punto_de_encuentro: data.address,
                coordenadas: data.coordinates,
              }));
            }}
          />
          <FormHelperText>
            Selecciona el lugar en el mapa donde se realizará la aventura.
          </FormHelperText>
        </FormControl>
      </Box>
    );
  };
  let Cuarto = ({}) => {
    return (
      <Box sx={{ display: "grid", gap: 3 }}>
        <FormControl>
          <FormLabel>Categoría</FormLabel>
          <Autocomplete
            options={categorias.map((x) => {
              return x.nombre_categoria;
            })}
          />
          <FormHelperText>Ejemplo: Senderismo, Camping, etc</FormHelperText>
        </FormControl>
        <FormControl>
          <FormLabel>Nivel de Dificultad</FormLabel>
          <Autocomplete
            options={niveles.map((x) => {
              return x.nombre_nivel;
            })}
          />
          <FormHelperText>
            Indica si es principiante, intermedio o avanzado.
          </FormHelperText>
        </FormControl>
      </Box>
    );
  };
  let Quinto = ({}) => {
    return (
      <Box sx={{ display: "grid", gap: 1 }}>
        <FormControl>
          <FormLabel>Imagen de la Aventura</FormLabel>
          <AspectRatio
            variant="soft"
            objectFit="cover"
            sx={{ borderRadius: 5 }}
          >
            <img
              src={`https://amigoutdoors.nyc3.digitaloceanspaces.com/uploads/1767809428973-imagen.jpg`}
              alt={`Imagen de la Aventura`}
            />
          </AspectRatio>
          <FormHelperText>
            Una foto vale más que mil palabras: sube una imagen increíble del
            lugar.
          </FormHelperText>
        </FormControl>
      </Box>
    );
  };

  return (
    <Box sx={{ backgroundColor: "#f0f4f8", borderRadius: 5, padding: 5 }}>
      <Box sx={{ display: "grid", gap: 1 }}>
        <Typography level="title-lg">Publica tu Aventura</Typography>
        <Typography level="body-sm" sx={{ marginTop: 0.5 }}>
          Completa los campos para crear una aventura y ofrecer una experiencia
          inolvidable a la comunidad. Los usuarios podrán ver los detalles y
          unirse a ella.
        </Typography>
      </Box>
      <Divider sx={{ marginTop: 5 }} />
      <Box
        sx={{
          display: "flex",
          width: "100%",
          justifyContent: "center",
          alignItems: "center",
          alignContent: "center",
        }}
      >
        <Box
          sx={{
            display: "grid",
            marginTop: 5,
            gap: 2,
            width: "100%",
          }}
        >
          <Box sx={{ width: "100%" }}>
            {posicion === 0 ? (
              <Box>
                <FormControl>
                  <FormLabel>Titulo de la Aventura</FormLabel>
                  <Input
                    onChange={(x) => {
                      setFormData((valoranterior) => ({
                        ...valoranterior,
                        titulo: x.target.value,
                      }));
                    }}
                    value={formData.titulo}
                  />
                </FormControl>
                <FormControl>
                  <FormLabel>Descripción</FormLabel>
                  <Textarea
                    minRows={4}
                    onChange={(x, value) => {
                      setFormData((valoranterior) => ({
                        ...valoranterior,
                        descripcion: x.target.value.slice(0, 300),
                      }));
                    }}
                    value={formData.descripcion}
                  />
                  <FormHelperText>
                    Incluye detalles emocionantes sobre la aventura (máximo 300
                    caracteres).
                  </FormHelperText>
                </FormControl>
              </Box>
            ) : null}
            {posicion === 1 ? (
              <Box sx={{ display: "grid", gap: 1 }}>
                <FormControl>
                  <FormLabel>Pais</FormLabel>
                  <Autocomplete
                    options={pais}
                    onChange={(event, value) => {
                      setCiudad(getCities(value));
                      setFormData((valoranterior) => ({
                        ...valoranterior,
                        pais: value,
                      }));
                    }}
                  />
                </FormControl>
                <FormControl>
                  <FormLabel>Ciudad</FormLabel>
                  <Autocomplete
                    disabled={ciudad ? false : true}
                    options={ciudad}
                    onChange={(event, value) => {
                      setFormData((valoranterior) => ({
                        ...valoranterior,
                        ciudad: value,
                      }));
                    }}
                  />
                </FormControl>
                <FormControl>
                  <FormLabel>Fecha de salida</FormLabel>
                  <Calendario onDateChange={handleDateChange} />
                </FormControl>
              </Box>
            ) : null}
            {posicion === 2 ? (
              <Box sx={{ display: "grid", gap: 1 }}>
                <FormControl>
                  <FormLabel>Ubicacion</FormLabel>
                  <Mapa
                    onLocationSelect={(data) => {
                      setFormData((prevData) => ({
                        ...prevData,
                        punto_de_encuentro: data.address,
                        coordenadas: data.coordinates,
                      }));
                    }}
                  />
                  <FormHelperText>
                    Selecciona el lugar en el mapa donde se realizará la
                    aventura.
                  </FormHelperText>
                </FormControl>
              </Box>
            ) : null}
            {posicion === 3 ? (
              <Box sx={{ display: "grid", gap: 3 }}>
                <FormControl>
                  <FormLabel>Categoría</FormLabel>
                  <Autocomplete
                    options={categorias.map((x) => {
                      return x.nombre_categoria;
                    })}
                    onChange={(event, value) => {
                      setFormData((x) => ({ ...x, categoria: value }));
                    }}
                  />
                  <FormHelperText>
                    Ejemplo: Senderismo, Camping, etc
                  </FormHelperText>
                </FormControl>
                <FormControl>
                  <FormLabel>Nivel de Dificultad</FormLabel>
                  <Autocomplete
                    options={niveles.map((x) => {
                      return x.nombre_nivel;
                    })}
                    onChange={(event, value) => {
                      setFormData((x) => ({ ...x, nivel: value }));
                    }}
                  />
                  <FormHelperText>
                    Indica si es principiante, intermedio o avanzado.
                  </FormHelperText>
                </FormControl>
              </Box>
            ) : null}
            {posicion === 4 ? (
              <Box sx={{ display: "grid", gap: 3 }}>
                <FormControl>
                  <FormLabel>Precio</FormLabel>
                  <Input
                    type={"text"}
                    startDecorator={
                      <Box>
                        <Typography sx={{ color: "#545e67" }}>$</Typography>
                      </Box>
                    }
                    endDecorator={
                      <Box>
                        <Typography sx={{ color: "#545e67" }}>CLP</Typography>
                      </Box>
                    }
                    onChange={(x) => {
                      setFormData((valoranterior) => ({
                        ...valoranterior,
                        precio: x.target.value
                          .replace(/[^0-9]/g, "")
                          .slice(0, 6),
                      }));
                    }}
                    value={formatearCLP(formData.precio)}
                    inputMode="numeric"
                    pattern="[0-9]*"
                  />
                  <FormHelperText>
                    Ingresa el valor por persona en pesos chilenos (CLP).
                  </FormHelperText>
                </FormControl>
                <FormControl>
                  <FormLabel>Cupos disponibles</FormLabel>
                  <Input
                    type={"number"}
                    onChange={(x) => {
                      let valor = x.target.value;
                      if (valor > 10) {
                        setFormData((valoranterior) => ({
                          ...valoranterior,
                          cupos: 10,
                        }));
                      } else {
                        setFormData((valoranterior) => ({
                          ...valoranterior,
                          cupos: x.target.value,
                        }));
                      }
                    }}
                    value={formData.cupos}
                  />
                  <FormHelperText>
                    Indica la cantidad de cupos disponibles (máximo 10
                    participantes).
                  </FormHelperText>
                </FormControl>
              </Box>
            ) : null}
            {posicion === 5 ? (
              <Box sx={{ display: "grid", gap: 1 }}>
                <Box sx={{ marginBottom: 2 }}>
                  <AspectRatio variant="outlined" sx={{ borderRadius: "5px" }}>
                    {vistaPrevia ? (
                      <img
                        src={vistaPrevia}
                        alt="Vista previa"
                        style={{
                          width: "100%",
                          height: "100%",
                          borderRadius: "5px",
                        }}
                      />
                    ) : (
                      <div>
                        <ImageIcon sx={{ fontSize: "3rem", opacity: 0.2 }} />
                      </div>
                    )}
                  </AspectRatio>
                </Box>

                <Box>
                  <input
                    type="file"
                    accept="image/*"
                    id="subir-foto"
                    style={{ display: "none" }}
                    onChange={manejarSubirFoto}
                  />
                  <label htmlFor="subir-foto">
                    <Button
                      component="span"
                      variant="outlined"
                      color="neutral"
                      startDecorator={<CloudUploadIcon />}
                      sx={{ marginBottom: "1rem", width: "100%" }}
                    >
                      Subir Foto de Perfil
                    </Button>
                  </label>
                </Box>
              </Box>
            ) : null}
          </Box>
          {posicion === 0 ? (
            <Button
              variant="outlined"
              color="neutral"
              onClick={() => {
                setPosicion(posicion + 1);
              }}
            >
              {boton}
            </Button>
          ) : null}
          {posicion > 0 ? (
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Button
                variant="plain"
                color="neutral"
                onClick={() => setPosicion(posicion - 1)}
              >
                Retroceder
              </Button>
              <Button
                variant="outlined"
                color="neutral"
                onClick={() => {
                  if (posicion < 5) {
                    setPosicion(posicion + 1);
                    console.log(formData);
                  }
                  if (posicion === 4) {
                    setBoton("Publicar Aventura");
                  }
                  if (posicion === 5) {
                    enviarFormulario();
                  }
                }}
                disabled={estadoBoton}
              >
                {boton}
              </Button>
            </Box>
          ) : null}
        </Box>
      </Box>
    </Box>
  );
};

export default function PublicarAventuras() {
  let [posicion, setPosicion] = react.useState(0);
  let [pais, setPais] = react.useState(getCountries());
  let [ciudad, setCiudad] = react.useState();
  let [formData, setFormData] = react.useState({
    titulo: "",
    descripcion: "",
    pais: "",
    ciudad: "",
    fecha: "",
    imagen: "",
    punto_de_encuentro: "",
    coordenadas: "",
    categoria: "",
    nivel: "",
    precio: "",
    cupos: "",
  });
  let [categorias, setCategorias] = react.useState();
  let [niveles, setNiveles] = react.useState();
  let [vistaPrevia, setVistaPrevia] = react.useState(false);
  let [boton, setBoton] = react.useState("Siguiente");
  let [estadoalerta, setestadoAlerta] = react.useState(false);
  let [contenidoAlerta, setcontenidoAlerta] = react.useState({
    titulo: "",
    contenido: "",
    icono: "",
    color: "",
    decorator: "",
  });
  let [estadoBoton, setEstadoBoton] = react.useState(false);
  let navigate = useNavigate();

  async function enviarFormulario() {
    try {
      setEstadoBoton(true);
      /* Validar datos */
      function validarFormData(data) {
        const campos = [
          "titulo",
          "descripcion",
          "pais",
          "ciudad",
          "fecha",
          "categoria",
          "nivel",
          "punto_de_encuentro",
          "coordenadas",
        ];

        for (let campo of campos) {
          if (
            !data[campo] ||
            (typeof data[campo] === "string" && data[campo].trim() === "")
          ) {
            throw new Error(`El campo "${campo}" es obligatorio`);
          }
        }

        // Validación especial imagen
        if (!(data.imagen instanceof File)) {
          throw new Error("Debes subir una imagen válida");
        }

        // Validación coordenadas (si es objeto)
        if (typeof data.coordenadas === "object") {
          if (data.coordenadas.lat == null || data.coordenadas.lng == null) {
            throw new Error("Coordenadas inválidas");
          }
        }
      }

      /* Validar datos */
      validarFormData(formData); // 👈 aquí explota si algo falta

      let formulario = new FormData();

      let token = localStorage.getItem("token");

      formulario.append("titulo", formData.titulo || "");
      formulario.append("descripcion", formData.descripcion || "");
      formulario.append("pais", formData.pais || "");
      formulario.append("ciudad", formData.ciudad || "");
      formulario.append("fecha", formData.fecha || "");
      formulario.append("categoria", formData.categoria || "");
      formulario.append("nivel", formData.nivel || "");
      formulario.append("imagen", formData.imagen, formData.imagen.name);
      formulario.append("coordenadas", JSON.stringify(formData.coordenadas));
      formulario.append("punto_de_encuentro", formData.punto_de_encuentro);
      formulario.append("precio", formData.precio);
      formulario.append("cupos", formData.cupos);

      let crearAventura = await axios.post(
        `${process.env.REACT_APP_FRONTEND_URL}/api/escritorio/crear-aventura`,
        formulario,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setestadoAlerta(true);
      setcontenidoAlerta(() => ({
        contenido: `Aventura creada exitosamente`,
        color: "success",
        decorator: <HikingIcon />,
      }));

      setTimeout(() => {
        navigate("/panel/escritorio/aventuras-publicadas");
      }, 3000);
    } catch (err) {
      console.log("Tenemos un error al enviar el Formulario");
      setEstadoBoton(true);
      setestadoAlerta(true);
      setcontenidoAlerta(() => ({
        contenido: `Faltan campos por rellenar`,
        color: "danger",
        decorator: <ErrorIcon />,
      }));
      setTimeout(() => {
        setestadoAlerta(false);
        setEstadoBoton(false);
      }, 3000);
    }
  }

  /* SET FECHA */

  const handleDateChange = (newDate) => {
    setFormData((prevData) => ({
      ...prevData,
      fecha: newDate ? newDate.format("YYYY-MM-DD") : "", // Formato de fecha deseado
    }));
  };
  /* SET FECHA */

  /*Categorias y niveles */

  useEffect(() => {
    async function getInfo() {
      let token = localStorage.getItem("token");
      let getCategorias = await axios.get(
        `${process.env.REACT_APP_FRONTEND_URL}/api/categorias`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      let getNiveles = await axios.get(
        `${process.env.REACT_APP_FRONTEND_URL}/api/niveles`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      console.log(getCategorias);
      setCategorias(getCategorias.data);
      setNiveles(getNiveles.data);
    }
    getInfo();
  }, []);

  /*Categorias y niveles */

  /* SUBIR FOTO LO HIZO CHATGPT  JUNTO CON COMPRESION DE IMAGEN Y CONVERSIÓN DE ARCHIVO*/

  const manejarSubirFoto = async (event) => {
    const archivo = event.target.files[0];
    if (archivo) {
      let opciones = {
        maxSizeMB: 1, // Máximo 1MB
        maxWidthOrHeight: 1024, // Redimensionar si es necesario
        useWebWorker: true,
      };
      try {
        let imagenRecibida = archivo;
        /* EN CASO DE ARCHIVOS .HEIC */

        if (
          imagenRecibida.type === "image/heic" ||
          imagenRecibida.type === "image/heif"
        ) {
          let blob = await heic2any({
            blob: archivo,
            toType: "image/jpeg",
            quality: 0.8,
          });
          imagenRecibida = new File([blob], "imagen_convertida.jpg", {
            type: "image/jpeg",
          });
        }

        /* EN CASO DE ARCHIVOS .HEIC */

        let imagenComprimida = await imageCompression(imagenRecibida, opciones);

        // Convertir a JPG si el formato es diferente
        const imagenBlob = await imageCompression(imagenComprimida, {
          fileType: "image/jpeg",
        });

        // Crear un nuevo archivo JPG
        const imagenJPG = new File([imagenBlob], "imagen.jpg", {
          type: "image/jpeg",
        });

        setFormData((valoranterior) => ({
          ...valoranterior,
          imagen: imagenJPG,
        }));
        setVistaPrevia(URL.createObjectURL(imagenJPG));
      } catch (err) {
        console.log("Tenemos un error para procesar la fotografía " + err);
      }
    }
  };

  useEffect(() => {
    return () => {
      if (vistaPrevia) {
        URL.revokeObjectURL(vistaPrevia);
      }
    };
  }, [vistaPrevia]);
  /* SUBIR FOTO LO HIZO CHATGPT  JUNTO CON COMPRESION DE IMAGEN Y CONVERSIÓN DE ARCHIVO*/

  return (
    <Box
      sx={{
        display: "flex",
        height: "100vh",
        width: "100vw",
        justifyContent: "flex-end",
      }}
    >
      <Box
        sx={{
          display: "flex",
          width: "94%",
          height: "100%",
          alignContent: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            height: "100%",
            width: "40%",
            paddingTop: 0,
            paddingLeft: 10,
            paddingRight: 10,
            justifyContent: "center",
            alignItems: "center",
            alignContent: "center",
          }}
        >
          {estadoalerta && (
            <Alert
              variant="soft"
              className="notificacion"
              color={contenidoAlerta.color}
              startDecorator={contenidoAlerta.decorator}
            >
              {contenidoAlerta.contenido}
            </Alert>
          )}
          <Formulario
            handleDateChange={handleDateChange}
            formData={formData}
            setFormData={setFormData}
            pais={pais}
            ciudad={ciudad}
            setCiudad={setCiudad}
            categorias={categorias}
            niveles={niveles}
            posicion={posicion}
            setPosicion={setPosicion}
            manejarSubirFoto={manejarSubirFoto}
            vistaPrevia={vistaPrevia}
            boton={boton}
            setBoton={setBoton}
            enviarFormulario={enviarFormulario}
            estadoBoton={estadoBoton}
          />
        </Box>
        <Box sx={{ height: "100%", width: "55%", padding: 5 }}>
          <Box>
            <AspectRatio ratio="2.3">
              {vistaPrevia ? (
                <img
                  src={`${vistaPrevia}`}
                  alt=""
                  style={{ borderRadius: 5 }}
                />
              ) : (
                <div>
                  <ImageIcon sx={{ fontSize: "3rem", opacity: 0.2 }} />
                </div>
              )}
              <Chip
                color="success"
                size="sm"
                sx={{ top: 5, left: 5, borderRadius: 5 }}
              >
                Vista Previa
              </Chip>
            </AspectRatio>
          </Box>
          <Box sx={{ marginTop: 3 }}>
            <Typography level="title-lg">{formData.titulo}</Typography>
          </Box>
          <Box
            sx={{
              backgroundColor: "#f0f4f8",
              borderRadius: 5,
              marginTop: 2,
              padding: 3,
              display: "grid",
              gap: 1,
            }}
          >
            <Typography
              level="title-sm"
              sx={{
                display: "flex",
                gap: 0.5,
                alignItems: "center",
                alignContent: "center",
              }}
            >
              <DescriptionIcon fontSize="inherit" />
              Descripción de la Aventura
            </Typography>
            <Typography level="body-sm">{formData.descripcion}</Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              marginTop: 3,
              justifyContent: "space-between",
            }}
          >
            <Box>
              <Typography
                level="title-sm"
                sx={{
                  display: "flex",
                  gap: 0.5,
                  alignItems: "center",
                  alignContent: "center",
                }}
              >
                <LocationOnIcon fontSize="inherit" />
                Punto de encuentro
              </Typography>
              <Typography level="body-sm">
                {formData.punto_de_encuentro}
              </Typography>
            </Box>
            <Box>
              <Button
                color="neutral"
                variant="soft"
                size="md"
                onClick={() => {
                  window.open(
                    `https://www.google.com/maps?q=${formData.coordenadas.lat},${formData.coordenadas.lng}`
                  );
                }}
              >
                Ver en Maps
              </Button>
            </Box>
          </Box>
          <Box sx={{ marginTop: 3, display: "flex", width: "100%", gap: 1 }}>
            <Box sx={{ width: "50%" }}>
              <Typography
                level="title-sm"
                sx={{
                  display: "flex",
                  gap: 0.5,
                  alignItems: "center",
                  alignContent: "center",
                }}
              >
                <ScheduleIcon fontSize="inherit" />
                Fecha de Ejecución
              </Typography>
              <Typography level="body-sm">{formData.fecha}</Typography>
            </Box>
            <Box sx={{ width: "50%" }}>
              <Typography
                level="title-sm"
                sx={{
                  display: "flex",
                  gap: 0.5,
                  alignItems: "center",
                  alignContent: "center",
                }}
              >
                <PublicIcon fontSize="inherit" />
                Ubicación
              </Typography>
              <Typography level="body-sm">
                {formData.ciudad}, {formData.pais}
              </Typography>
            </Box>
          </Box>
          <Box sx={{ marginTop: 3, display: "flex", width: "100%", gap: 1 }}>
            <Box sx={{ width: "50%" }}>
              <Typography
                level="title-sm"
                sx={{
                  display: "flex",
                  gap: 0.5,
                  alignItems: "center",
                  alignContent: "center",
                }}
              >
                <LayersIcon fontSize="inherit" />
                Categoría
              </Typography>
              <Typography level="body-sm">{formData.categoria}</Typography>
            </Box>
            <Box sx={{ width: "50%" }}>
              <Typography
                level="title-sm"
                sx={{
                  display: "flex",
                  gap: 0.5,
                  alignItems: "center",
                  alignContent: "center",
                }}
              >
                <PriorityHighIcon fontSize="inherit" />
                Nivel
              </Typography>
              <Typography level="body-sm">{formData.nivel}</Typography>
            </Box>
          </Box>
        </Box>
      </Box>
      <MenuEmpresas />
    </Box>
  );
}
